import React from 'react';
import PropTypes from 'prop-types';

import { GridContainerSt } from 'app/dealer/shared/components/Grid/Grid.css';

import {
  MenuBarSt,
  MenuItemButtonSt,
  MenuItemLinkSt,
} from './NavigationMenu.css';

const menuItemShape = PropTypes.shape({
  href: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.any,
  onClick: PropTypes.func,
});

export class NavigationMenu extends React.PureComponent {
  render() {
    const { className, menuItems } = this.props;

    return (
      <MenuBarSt className={className}>
        <GridContainerSt>
          {menuItems.map((menuItem, idx) => {
            const { href, isActive, label, onClick } = menuItem;
            const defaultProps = {
              onClick,
              isactive: isActive ? 1 : 0,
              key: idx,
            };
            const renderedItem = href ? (
              <MenuItemLinkSt {...defaultProps} to={href}>
                {label}
              </MenuItemLinkSt>
            ) : (
              <MenuItemButtonSt {...defaultProps}>{label}</MenuItemButtonSt>
            );

            return renderedItem;
          })}
        </GridContainerSt>
      </MenuBarSt>
    );
  }
}

NavigationMenu.propTypes = {
  className: PropTypes.string,
  menuItems: PropTypes.arrayOf(menuItemShape),
};

NavigationMenu.defaultProps = {
  className: '',
  menuItems: [],
};
